import React from 'react';

import CountryInfo from '../CountryInfo';

const TAX_SECTION = {
    title: 'Tax Refunds & Deferred Taxes',
    content: (
        <p>
            Business and private persons that can&apos;t make payments due to
            COVID can apply to get their taxes for the past three months
            retroactively refunded, as well as defer upcoming tax payments.
        </p>
    ),
    links: [
        {
            title: 'Möjlighet till anstånd med betalning på grund av coronaviruset',
            url: 'https://skatteverket.se/omoss/press/nyheter/2020/nyheter/mojlighettillanstandmedbetalningpagrundavcoronaviruset.5.1c68351d170ce554527435.html',
        },
        {
            title: 'Förslag om likviditetförstärkning via skattekontot',
            url: 'https://www.regeringen.se/artiklar/2020/03/forslag-om-likviditetforstarkning-via-skattekontot/',
        },
        {
            title: 'Ansökan - Anstånd med betalning av skatt p.g.a. tillfälliga betalningssvårigheter',
            url: 'https://www.skatteverket.se/privat/etjansterochblanketter/blanketterbroschyrer/blanketter/info/4305.4.39f16f103821c58f680006644.html',
        },
    ],
};

const COUNTRY_INFO = {
    countryName: 'Sweden',
    lastUpdated: 'March 21, 2020',
    introSection: (
        <p>
            Sweden has announced tax refunds & deferments as part of their
            economic plan.
        </p>
    ),
    sections: [TAX_SECTION],
};

const SwedenInfo = () => <CountryInfo info={COUNTRY_INFO} />;

export default SwedenInfo;
